// extracted by mini-css-extract-plugin
export default {"RemovedItemDetail":"styles_RemovedItemDetail__tpZg-","RemovedItemDetail__selected":"styles_RemovedItemDetail__selected__7JK1e"};